import { Component, OnInit, ViewChild, ElementRef, Input, ViewChildren, EventEmitter, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { forkJoin } from 'rxjs';

import { StateService, AuthService } from '../../../services';
import { } from '../../../models';
import { FormFunctions } from '../../../functions';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalSearchFilterItemTextComponent } from '../../modals';
import { } from '../../../shared/modals';
import { AuctionLotSearchFilterItemTextModel } from '../../models';

@Component({
    selector: 'auction-search-filter-item-text',
    styleUrls: ['./auction-search-filter-item-text.component.scss'],
    templateUrl: './auction-search-filter-item-text.component.html',
    host: { 'class': 'filter-item-text' },
})
export class AuctionSearchFilterItemTextComponent implements OnInit {

    @Input() model: AuctionLotSearchFilterItemTextModel;
    @Input() modalMode: boolean = true;

    @Output() updated = new EventEmitter();
    @Output() doEdit = new EventEmitter();

    constructor(public router: Router, private activatedRoute: ActivatedRoute, public stateService: StateService, private modalService: NgbModal, public authService: AuthService, public formFunctions: FormFunctions) {
        var me = this;
    }

    ngOnInit() {
        var me = this;
    }

    edit() {
        // console.log('edit');
        let me = this;

        if (me.modalMode) {
            const modalRef = me.modalService.open(ModalSearchFilterItemTextComponent, {
                scrollable: true,
                size: 'lg'
            });

            modalRef.componentInstance.model = { ...this.model }; // clone model
            modalRef.componentInstance.apply.subscribe(($e) => {
                // console.log($e);
                this.model.value = $e;
                this.updated.emit();
            });
        } else {
            me.doEdit.emit();
        }
    }

    remove(value) {
        // console.log('remove', value);
        this.model.value = '';
        this.updated.emit();
    }



}
